/** Soupers confirmés. Dan est l’un des 6 chasseurs. Daniel, pour les desserts, c’est Dan. */

export const HUNT_SUPPERS = [
  { evening: 1, who: "Éric", dish: "Pâtes au pesto + saucisses merguez" },
  { evening: 2, who: "Marcel", dish: "Filet de porc à l’érable + pommes de terre + asperges" },
  { evening: 3, who: "Dan", dish: "Pâté chinois" },
  { evening: 4, who: "Pierre", dish: "Poulet + légumes" },
  { evening: 5, who: "Steve", dish: "Macaroni" },
  { evening: 6, who: "Luc", dish: "Hamburger steak + patates + sauce au poivre + choux de Bruxelles" },
];

export const JOSEE_FOOD = {
  who: "Josée",
  note: "Contribution préparée. Josée n’est pas du groupe de chasse.",
  items: [
    "12 breakfast burritos",
    "12 saucisses McMuffin sans œuf à la demande d’Éric",
    "salsa maison",
    "betteraves maison",
    "pickles maison",
  ],
};

export const DANIEL_DESSERTS = {
  who: "Dan",
  items: [
    "carrés au sirop d’érable",
    "petits cornets pour Luc",
    "guimauves au chocolat",
    "Rocky Road",
    "nuts and bolts",
    "biscuits à venir",
  ],
};
